import {  Text, Stack, Select } from "@chakra-ui/react";
import { FormModal2, Input, InputCurrencyBRL } from "@/components";
import { useForm } from "react-hook-form";
import { z } from 'zod';
import { useCreditCard } from "@/hooks/useCreditCard";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";

interface NewCreditCardProps {
    isOpen: boolean;
    onClose: ()=> void;
}
export default function NewCreditCard({isOpen, onClose}: NewCreditCardProps) {
  const schema = z.object({
    cardName: z.string().min(1, 'Este campo é obrigatório'),
    newLimit: z.string().optional(),
    limitType: z.string().min(1, 'Este campo é obrigatório'),
  }).refine((data) => {
    if (data.limitType === 'LIMIT_BALANCE') {
      return data.newLimit && data.newLimit.length > 0;
    }
    return true;
  }, {
    message: 'O limite é obrigatório quando o tipo é LIMIT_BALANCE',
    path: ['newLimit']
  });

  const createCreditCardForm = useForm<any>({
    resolver: zodResolver(schema),
    shouldFocusError: false,
  })
  const { createCreditCard, loading, getInitialData } = useCreditCard();
  async function onSubmit(data) {
    try {
        await createCreditCard(data);
        
    } finally {
      onClose();
      createCreditCardForm.reset();
      getInitialData();
    }
  }
  useEffect(() => {
    if (isOpen) {
      createCreditCardForm.setValue("limitType", "FREE_BALANCE");
    }
  }, [isOpen]);
  const Step1 = () => {
    return (
      <Stack
          spacing={2}
      >
        <Text
          fontSize={["14px"]}
        >
          Inclua um nome para identificar o cartão:
        </Text>
        <Input
          label=""
          labelColor="#8A94A8"
          placeholder="Identifique o cartão"
          name="cardName"
          type="text"
          register={{ ...createCreditCardForm.register("cardName") }}
          borderRadius="8px"
          errors={createCreditCardForm.formState.errors.cardName?.message}
          maxLength={20}
          _focus={{
            borderColor: "black",
          }}
        />
        <Text
          fontSize={["14px"]}
        >
          Selecione o tipo de limite:
        </Text>
        <Select
              name="limitType"
              value={createCreditCardForm.watch("limitType")}
              onChange={(e) => createCreditCardForm.setValue("limitType", e.target.value)}
              borderRadius="8px"
              _focus={{
                borderColor: "black",
              }}
              color="gray.500" 
              border="1px solid"
              borderColor="newGray.200"
              _hover={{
                  cursor: "pointer"
              }}
          >
              <option value="FREE_BALANCE">Saldo Livre</option>
              <option value="LIMIT_BALANCE">Limite Fixo</option>
        </Select>
        {createCreditCardForm.watch("limitType") === "LIMIT_BALANCE" && (
          <>
            <Text
              fontSize={["14px"]}
            >
              Defina o limite do cartão:
            </Text>
            <InputCurrencyBRL
              onChangeInput={e => createCreditCardForm.setValue("newLimit", e)}
              fontSize="12px"
              borderRadius="8px"
              isLimit
              _focus={{
                borderColor: "black",
              }}
            />
          </>
        )}
      </Stack>
    );
  };
  const steps = [
    {
      title: "Informações Básicas",
      content: <Step1 />,
      onNext: () => {createCreditCardForm.handleSubmit(onSubmit)},
      onBack: () => {}
    },
  ];

  return (
    <>
      <FormModal2
        isOpen={isOpen}
        onClose={onClose}
        title="Novo cartão de crédito"
        handleConfirmModal={createCreditCardForm.handleSubmit(onSubmit)}
        isSubmitting={loading}
        confirmationButtonText="Gerar cartão"
        disableWhenIsFormEmpty={false}
        type="ADD"
        steps={steps}
      />
    </>
  );
};